export default __webpack_public_path__ + "static/media/carousel-4.50e6b4e1.jpg";